<!-- Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. -->

<div
	#container
	class="container resizable-container-zindex hover-over-container"
	[style.top.px]="y"
	[style.left.px]="x"
	[style.width.px]="width"
	[style.zIndex]="currentZIndex"
>
	<div class="content-area">
		<ng-content></ng-content>
	</div>
</div>
